import ecbrApi from '../../../services/ecbrApi'
import { useQuery } from 'react-query'

export const usePendingApprovalAnswersQuery = (searchParameters, setError) => {
  return useQuery(
    ['pending-approval-answers', searchParameters],
    async ({ queryKey: [_, params] }) => {
      try {
        const resp = await ecbrApi.questionsAnswers.getAllPendingApproval(
          params
        )

        const { searchValue, brandIds, certificateId } = params

        let filteredAnswers = resp.data
        if (searchValue) {
          filteredAnswers = filteredAnswers.filter(
            (answer) =>
              answer?.question?.description
                ?.toLowerCase()
                .includes(searchValue.toLowerCase()) ||
              answer?.question?.topic?.name
                ?.toLowerCase()
                .includes(searchValue.toLowerCase()) ||
              answer?.question?.topic?.pillar?.name
                ?.toLowerCase()
                .includes(searchValue.toLowerCase())
          )
        }

        if (brandIds?.length) {
          filteredAnswers = filteredAnswers.filter((answer) =>
            brandIds.includes(answer?.certificate?.brandId)
          )
        }

        if (certificateId) {
          filteredAnswers = filteredAnswers.filter(
            (answer) => answer?.certificateId === certificateId
          )
        }

        return filteredAnswers
      } catch (err) {
        setError(err.message)
      }
    },
    {
      staleTime: 1000 * 60 * 1,
      onSuccess: () => {
        setError('')
      },
      onError: () => {
        setError(
          'Não foi possível carregar as respostas pendentes de aprovação.'
        )
      }
    }
  )
}
